import { render, staticRenderFns } from "./ShareToPortal.vue?vue&type=template&id=296a2b9a&scoped=true&"
import script from "./ShareToPortal.vue?vue&type=script&lang=js&"
export * from "./ShareToPortal.vue?vue&type=script&lang=js&"
import style0 from "./ShareToPortal.vue?vue&type=style&index=0&id=296a2b9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296a2b9a",
  null
  
)

export default component.exports